import {API_URL} from "../config";
import axios from "../utils/axios";

class ParkingZoneGroupRepository
{
    save(data) {
        return axios.post(API_URL + "/ParkingZoneGroup/Save", data);
    }

    getAll(filter) {
        return axios.get(API_URL + "/ParkingZoneGroup/List?", {params: filter});
    }

    getById(id) {
        return axios.get(API_URL + `/ParkingZoneGroup/${id}`);
    }

    delete(id) {
        return axios.delete(API_URL + `/ParkingZoneGroup/${id}`);
    }

    getSelector() {
        return axios.get(API_URL + `/ParkingZoneGroup/Selector`);
    }

}

export default ParkingZoneGroupRepository;